import { render, staticRenderFns } from "./form_libros_new.vue?vue&type=template&id=4dd8db12&scoped=true"
import script from "./form_libros_new.vue?vue&type=script&lang=js"
export * from "./form_libros_new.vue?vue&type=script&lang=js"
import style0 from "./form_libros_new.vue?vue&type=style&index=0&id=4dd8db12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8db12",
  null
  
)

export default component.exports